import { render } from "./SpecialitySelector.vue?vue&type=template&id=2df10818&scoped=true"
import script from "./SpecialitySelector.vue?vue&type=script&lang=js"
export * from "./SpecialitySelector.vue?vue&type=script&lang=js"

import "./SpecialitySelector.vue?vue&type=style&index=0&id=2df10818&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df10818"]])

export default __exports__